import { FAIRE_DIRECT_SIGN_UP_FROM_MARKETPLACE_240809 } from "@faire/web-api/indigofair/settings/FAIRE_DIRECT_SIGN_UP_FROM_MARKETPLACE_240809";
import { useEffect } from "react";

import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer/lib/isLoggedInRetailer";
import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingFaireDirectSignUpFromMarketplace = (): boolean =>
  useSetting(FAIRE_DIRECT_SIGN_UP_FROM_MARKETPLACE_240809, false);

export const getSettingFaireDirectSignUpFromMarketplace = (): boolean =>
  getSettingValueWithoutAssignment(
    FAIRE_DIRECT_SIGN_UP_FROM_MARKETPLACE_240809,
    false
  );

export const useAssignSettingFaireDirectSignUpFromMarketplaceEffect = () => {
  const assignSettingFaireDirectSignUpFromMarketplace = useAssignSetting(
    FAIRE_DIRECT_SIGN_UP_FROM_MARKETPLACE_240809
  );
  const isLoggedInRetailerOrBrandPreview =
    useIsLoggedInRetailerOrBrandPreview();
  const { isFaireDirectActiveInLoggedOut } = useFaireDirectBrand();

  useEffect(() => {
    if (!isLoggedInRetailerOrBrandPreview && isFaireDirectActiveInLoggedOut) {
      assignSettingFaireDirectSignUpFromMarketplace();
    }
  }, [
    assignSettingFaireDirectSignUpFromMarketplace,
    isFaireDirectActiveInLoggedOut,
    isLoggedInRetailerOrBrandPreview,
  ]);
};
